import sp1 from '../images/shop/1.jpg'
import sp2 from '../images/shop/2.jpg'
import sp3 from '../images/shop/3.jpg'
import sp4 from '../images/shop/4.jpg'
import sp5 from '../images/shop/5.jpg'
import sp6 from '../images/shop/6.jpg'


const Prtoducts = [
   {
     id:'1',
     shopImg:sp1,
     price:"25.00",
     off:"$20.00",
     title:"Principles and Policies",
     btn:"Add to cart",
   },
   {
     id:'2',
     shopImg:sp2,
     price:"25.00",
     off:"$20.00",
     title:"Winning Arguments",
     btn:"Add to cart",
   },
   {
     id:'3',
     shopImg:sp3,
     price:"25.00",
     off:"$20.00",
     title:"To Kill a Mockingbird",
     btn:"Add to cart",
   },
   {
     id:'4',
     shopImg:sp4,
     price:"25.00",
     off:"$20.00",
     title:"Learning the Law",
     btn:"Add to cart",
   },
   {
     id:'5',
     shopImg:sp5,
     price:"25.00",
     off:"$20.00",
     title:"Lord Denning, A Life",
     btn:"Add to cart",
   },
   {
     id:'6',
     shopImg:sp6,
     price:"25.00",
     off:"$20.00",
     title:"Blue Hoodi",
     btn:"Add to cart",
   },
]

export default Prtoducts;